import { Component, Input } from '@angular/core';

import { AppMaterialModule } from 'src/app/modules/app-material.module';

@Component({
  selector: 'app-add-button',
  imports: [AppMaterialModule],
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss'],
})
export class AddButtonComponent {
  @Input() disabled = false;
}
